'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * @ngdoc service
 * @name $dureeFormat
 * @function
 *
 * @description la valeur est une Period jodatime dont les composants sont stockés dans un tableau iValues[year, month, week, days, hours, minutes, seconds]
 *
 *
 */
ngModule.factory("$dureeFormat", function (stringUtils) {
  var defaultPlaceHolder = "-";
  var $numberFormat = function $numberFormat(value) {
    if (value == null) {
      return defaultPlaceHolder;
    }
    var res = "";
    var years = value.iValues[0];
    var months = value.iValues[1];
    if (years === 1) {
      res += years + " an";
    } else if (years > 1) {
      res += years + " ans";
    }
    if (months > 0 && years > 0) {
      res += " ";
    }
    if (months > 0 || years === 0) {
      if (years > 0) {
        res += " et ";
      }
      res += months + " mois";
    }
    return res;
  };
  _.extend($numberFormat, {
    /**
     * formatage d'un nombre de mois en années/mois : (ex : 276 --> 2 ans et 3 mois)
     *
     * @param value un nombre de mois
     */
    dureeFromMois: function dureeFromMois(value) {
      if (value == null) {
        return defaultPlaceHolder;
      }
      var res = "";
      var years = Math.floor(value / 12);
      var months = value % 12;
      if (years === 1) {
        res += years + " an ";
      } else if (years > 1) {
        res += years + " ans ";
      }
      if (months > 0 || years === 0) {
        if (years > 0) {
          res += " et ";
        }
        res += months + " mois ";
      }
      return res;
    },
    /**
     *
     * @param monthAmount si dépasse 11 alors sera ramené à une valeur entre 0 et 11 et les années incrémentées du nombre d'année correspondant
     * @param yearsAmount optionnel
     * @returns {string}
     */
    dureeFromAnneeEtMoisEtJour: function dureeFromAnneeEtMoisEtJour(yearsAmount, monthAmount, days) {
      var res = "";
      var years = Math.floor(monthAmount / 12);
      var months = monthAmount % 12;
      if (yearsAmount) {
        years += yearsAmount;
      }
      if (years === 1) {
        res += years + " an ";
      } else if (years > 1) {
        res += years + " ans ";
      }
      if (months > 0 || years === 0) {
        if (years > 0 && !(days > 0)) {
          res += " et ";
        }
        res += months + " mois ";
      }
      if (days > 0) {
        if (days > 1) {
          res += " et " + days + " jours";
        } else {
          res += " et " + days + " jour";
        }
      }
      return res;
    }
  });
  return $numberFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/duree/dureeFormat.js
// module id = 2727
// module chunks = 13